import { Actions, Entities } from '@space-core/datahub'

import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { REDIRECT_ORIGIN_PARAM } from '@space-shell/constant/redirect'
import { BaseNames } from '@space-shell/core/router/constants'
import { REDIRECT_NEW_CLUB } from '@space-shell/core/store'
import { useParams, useSearchParams } from 'react-router-dom'

const useLegacyClubRedirect = () => {
  const [searchParams] = useSearchParams()
  const { membership, lang } = useParams()
  const { sendDataHubEvent } = useDataHubEvents()

  const productId = searchParams.get('productId')
  const isRedirectedUser = searchParams.get('origin') === REDIRECT_ORIGIN_PARAM

  const redirectToCourseConsumptionPage = () => {
    const redirectLink = BaseNames.contentConsume(
      membership as string,
      lang as string,
      productId as string
    )

    const subdomain = searchParams.get('subdomain') || ''

    window.localStorage.setItem(REDIRECT_NEW_CLUB, JSON.stringify({ subdomain }))

    const contentConsumeUrl = `${window.location.origin}${redirectLink}${window.location.search}`

    window.location.replace(contentConsumeUrl)
  }

  const redirectLoggedUser = () => {
    sendDataHubEvent({
      group: Entities.LEGACY_CLUB_REDIRECT,
      name: Actions.AUTOMATIC_REDIRECT_USER,
      params: {
        product: {
          name: '',
          id: Number(productId)
        }
      }
    })

    redirectToCourseConsumptionPage()
  }

  const handleLoginClick = () => {
    sendDataHubEvent({
      group: Entities.LEGACY_CLUB_REDIRECT,
      name: Actions.CLICK_REDIRECT_USER,
      params: {
        product: {
          name: '',
          id: Number(productId)
        }
      }
    })

    redirectToCourseConsumptionPage()
  }

  return { isRedirectedUser, handleLoginClick, redirectLoggedUser }
}

export { useLegacyClubRedirect }
